import { takeEvery, takeLatest } from 'redux-saga/effects';
import { RULES_MODULE } from '../../../configs/moduleNames';
import {
  LOAD_RULES_LIST,
  CREATE_RULES,
  DELETE_RULES,
  EDIT_RULES_BY_ID,
  LOAD_RULES_BY_ID,
} from '../actions';

import loadRulesList from './loadRulesList';
import createRules from './createRules';
import loadRulesById from './loadRulesById';
import editRulesById from './editRulesById';
import deleteRules from './deleteRules';

export default function* watchDashboard() {
  yield takeLatest(RULES_MODULE + LOAD_RULES_LIST, loadRulesList);
  yield takeLatest(RULES_MODULE + CREATE_RULES, createRules);
  yield takeEvery(RULES_MODULE + LOAD_RULES_BY_ID, loadRulesById);
  yield takeEvery(RULES_MODULE + EDIT_RULES_BY_ID, editRulesById);
  yield takeEvery(RULES_MODULE + DELETE_RULES, deleteRules);
}
